import type { RouteRecordRaw } from 'vue-router';

export const TRADE_ROUTER: RouteRecordRaw[] = [
  {
    path: '/adjustment/trade',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/adjustment/trade/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/adjustment/trade/views/List.vue'),
        name: 'Trade List',
        meta: {
          title: '거래목록',
        },
      },
      {
        path: 'create',
        component: () => import('@/modules/adjustment/trade/views/Create.vue'),
        name: 'Trade Create',
        meta: {
          title: '거래등록',
        },
      },
    ],
  },
];
